export enum ComplianceSalesActionKeys {
  FETCH_SALES_COMPLIANCE = 'FETCH_SALES_COMPLIANCE',
  SET_SALES_COMPLIANCE = 'SET_SALES_COMPLIANCE',
  TOGGLE_SALES_COMPLIANCE_LOADING = 'TOGGLE_SALES_COMPLIANCE_LOADING'
}
